import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { PropertyDropdown } from "../../components/Dashboard/PropertyDropdown";
import { getSearchParamNumber } from "../../services/nav/QueryStringHelpers";
import { ICompanyClaims } from "../../services/zeos-api/contracts/Account";
import { createLogger } from "../../services/Logger";
import { DashboardFooter } from "../dashboard/layout/DashboardFooter";
import { DashboardHeader } from "../dashboard/layout/DashboardHeader";
import { ProjectsTable } from "./ProjectsTable";

export const ProjectsListScreen = () => {
  const log = createLogger("ProjectsListScreen");
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeCompany, setActiveCompany] = useState<ICompanyClaims>();
  const [selectedPropertyId, setSelectedPropertyId] = useState<number | null>(
    null
  );
  const [agentPrompt, setAgentPrompt] = useState("");
  const [searchParams] = useSearchParams();
  const urlPropertyId = getSearchParamNumber("property", searchParams);
  const urlCompanyId = getSearchParamNumber("company", searchParams);

  useEffect(() => {
    if (!activeCompany) {
      return;
    }

    if (urlPropertyId) {
      setSelectedPropertyId(urlPropertyId);
      return;
    }

    if (activeCompany.properties.length > 0) {
      setSelectedPropertyId(activeCompany.properties[0].propertyId);
      return;
    }

    setSelectedPropertyId(null);
  }, [activeCompany, urlPropertyId]);

  const handlePropertySelect = (propertyId: number) => {
    setSelectedPropertyId(propertyId);
  };

  const handleStartProject = () => {
    if (!selectedPropertyId) {
      return;
    }
    const params = new URLSearchParams();
    params.set("property", String(selectedPropertyId));
    if (urlCompanyId != null) {
      params.set("company", String(urlCompanyId));
    }
    navigate(`/projects/start?${params.toString()}`);
  };

  const handleAskAgent = () => {
    log.info("Ask Incentive Agent (stub)", { prompt: agentPrompt });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <DashboardHeader companyCallback={setActiveCompany} />
      <main className="bg-zeos-white-md flex-grow">
        <div
          className="grid grid-cols-12 gap-6 font-sans w-full max-w-[1600px] mx-auto px-4 py-6 lg:px-6"
          onClick={() => setIsDropdownOpen(false)}
        >
          <div className="col-span-12">
            <PropertyDropdown
              activeCompany={activeCompany}
              label="Projects"
              isOpen={isDropdownOpen}
              setIsOpen={setIsDropdownOpen}
              selectedPropertyId={selectedPropertyId || undefined}
              onPropertySelect={handlePropertySelect}
              enableNavigateToProperty={true}
            />
            <div className="flex flex-col gap-4 mt-4">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-end gap-4">
                <button
                  type="button"
                  onClick={handleStartProject}
                  className="px-6 py-3 rounded bg-zeos-orange-md text-white text-sm font-semibold hover:bg-zeos-orange-dk transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 disabled:opacity-60 disabled:cursor-not-allowed"
                  disabled={!selectedPropertyId}
                >
                  Start Project
                </button>
              </div>
              {/* Ask the Incentive Agent — hidden until functionality is ready
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-end gap-2 bg-white border border-gray-200 rounded px-3 py-2">
                <input
                  type="text"
                  placeholder="Ask the Incentive Agent"
                  value={agentPrompt}
                  onChange={(e) => setAgentPrompt(e.target.value)}
                  className="w-full outline-none bg-transparent text-sm text-gray-700"
                />
                <button
                  type="button"
                  onClick={handleAskAgent}
                  className="px-4 py-2 rounded border border-zeos-orange-md text-zeos-orange-md hover:bg-orange-50 transition-all duration-300"
                >
                  Ask
                </button>
              </div>
              */}
            </div>
          </div>

          <div className="col-span-12">
            <ProjectsTable
              selectedProperty={selectedPropertyId}
            />
          </div>
        </div>
      </main>
      <DashboardFooter />
    </div>
  );
};
